import React, { SyntheticEvent, useEffect, useState } from 'react';
import UpsertModal from '../../../../../../components/General/UpsertModal';
import { StudentRepresentativeData } from '../types';

const TITLE = 'apoderados';

function UpsertRepresentativeModal(
  {
    allItems,
    modalEdit,
    setModalEdit,
    handleCloseModal,
    modalValues,
    setModalValues,
    handleFieldChange,
    itemsUI,
    upsertFunction,
  }: {
    allItems: { items: Array<StudentRepresentativeData>, totalItems: number },
    modalEdit: { id: string, open: boolean },
    setModalEdit: React.Dispatch<React.SetStateAction<{
      id: string;
      open: boolean;
    }>>,
    handleCloseModal: (setFunction: React.Dispatch<React.SetStateAction<{
      id: string;
      open: boolean;
    }>>) => void,
    modalValues: StudentRepresentativeData,
    setModalValues: React.Dispatch<React.SetStateAction<StudentRepresentativeData>>,
    handleFieldChange: (e: React.ChangeEvent<HTMLInputElement>
    | SyntheticEvent<Element, Event> | Date | File, source: string) => void,
    itemsUI: {
      label: string;
      key: string;
      showOnTable: boolean;
      showOnModal: boolean;
      typeField: string;
      selectFields?: object[];
      valueType: string;
    }[],
    upsertFunction: (id: string) => void,
  },
) {
  const [upsertFlag, setUpsertFlag] = useState(false);

  useEffect(() => {
    if (upsertFlag) {
      upsertFunction(modalEdit.id);
      setUpsertFlag(false);
    }
  }, [upsertFlag, modalEdit.id]);

  useEffect(() => {
    if (modalEdit.id !== '') {
      const auxSelectedItem = allItems.items.filter((elem) => elem.id === modalEdit.id);
      const selectedItem = auxSelectedItem[0];
      setModalValues({
        rut: selectedItem.rut,
        phoneNumber: selectedItem.phoneNumber,
        name: selectedItem.name,
        lastname: selectedItem.lastname,
        email: selectedItem.email,
        relationToStudent: selectedItem.relationToStudent,
        birthDate: selectedItem.birthDate || '',
        nationality: selectedItem.nationality || '',
        maritalStatus: selectedItem.maritalStatus || '',
        profession: selectedItem.profession || '',
        address: selectedItem.address || '',
        commune: selectedItem.commune || '',
      });
    }
  }, [modalEdit.id]);

  return (
    <UpsertModal<StudentRepresentativeData>
      title={TITLE}
      modalAddEdit={modalEdit}
      setModalAddEdit={setModalEdit}
      handleCloseModal={handleCloseModal}
      modalValues={modalValues}
      handleFieldChange={handleFieldChange}
      itemsUI={modalEdit.id !== '' ? itemsUI : itemsUI.filter((elem) => elem.key !== 'relationToStudent')}
      handleAddFunction={() => setUpsertFlag(true)}
      handleEditFunction={() => setUpsertFlag(true)}
    />
  );
}

export default UpsertRepresentativeModal;
